var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-container"},[(!_vm.isClient)?_c('div',{staticClass:"header-container"},[_vm._m(0)]):_vm._e(),(!_vm.isClient)?_c('div',{staticClass:"header-zw"}):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-view"},[_c('img',{attrs:{"src":"/logo.png","alt":""}})])
}]

export { render, staticRenderFns }